// extracted by mini-css-extract-plugin
export default {"root":"BackHeader_root__Ae7Wj","bar":"BackHeader_bar__wWfPX","backBtn":"BackHeader_backBtn__8WPrb","backIcon":"BackHeader_backIcon__AEZX+","title":"BackHeader_title__A2bgq"};